import React, { useState, useEffect } from "react";
import { Input } from "../../components/input";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/outline";
import affinity_categories from "./affinity-categories.json";
import default_vendors from "./vendors.json";
import {
  getCatalogProductBySku,
  getCatalogProductVendorsBySku,
  createCatalogVendorSku,
  removeCatalogVendorSku,
  getProofTemplateUploadUrl,
  getCatalogProductPricesBySku,
  createCatalogProductPrice,
  removeCatalogProductPrice,
  getCatalogProductImagesBySku,
  createCatalogProductImage,
  createProofTemplate,
  getProofTemplatesBySku,
  createCatalogProduct,
  updateCatalogProduct,
  deleteProofTemplate,
  deleteImagesBySku,
  deleteCatalogProduct,
} from "../../services/axios";
import { FileFormatPicker } from "./ui";
import {
  PRINTED_DESIGN_AREAS,
  STOREFRONT_RENDER_AREAS,
  NECK_LABEL_AREA,
  canonicalizeDesignArea,
  designAreaLabel,
  sortDesignAreas,
  isBareSleeve,
} from "../../utils/design-areas";

import axios from "axios";
import { toast } from "sonner";

var uuid = require("uuid");

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const CreateProduct = (props) => {
  let [state, setState] = useState({
    id: "",
    brand: "",
    brand_errors: "",
    model: "",
    model_errors: "",
    sku: "",
    sku_errors: "",
    product_type: "",
    type_errors: "",
    description: "",
    description_errors: "",
    affinity_product_category_id: "",
    affinity_product_category_id_errors: "",
    default_vendor: "White Label DTG",
    default_vendor_errors: "",
    proof_templates: [],
    default_file_type: "",
  });

  const [images, setImages] = useState([]);
  const [newPrices, setNewPrices] = useState([]);
  const [prices, setPrices] = useState([]);
  const [proofTemplates, setProofTemplates] = useState([]);
  const [vendors, setVendors] = useState([]);

  let PID = props.match.params.id;
  let history = useHistory();

  let [psdFile, setPsdFile] = useState(null);
  let [csvFile, setCsvFile] = useState(null);
  let [csvState, setCsvState] = useState({
    url: "",
    progress: "0",
  });

  let [psdState, setPsdState] = useState({
    url: "",
    progress: "0",
  });

  const [affinityCategories, setAffinityCategories] = useState([]);
  const [selectedAffinityCategory, setSelectedAffinityCategory] = useState();

  const [defaultVendors, setDefaultVendors] = useState([]);
  const [selectedDefaultVendor, setSelectedDefaultVendor] = useState();

  useEffect(() => {
    if (affinity_categories) {
      let cats = affinity_categories.data.map(function (cat) {
        return {
          label: cat.name,
          value: cat,
        };
      });
      setAffinityCategories(cats);
      let affinity_product_category_id = affinity_categories.data.find(
        (x) => x.id === state.affinity_product_category_id
      );
      if (affinity_product_category_id) {
        setSelectedAffinityCategory({
          label: affinity_product_category_id.name,
          value: affinity_product_category_id,
        });
      }
    }
    if (default_vendors) {
      let vens = default_vendors.data.map(function (cat) {
        return {
          label: cat.label,
          value: cat,
        };
      });
      setDefaultVendors(vens);
      let default_vendor = default_vendors.data.find(
        (x) => x.name === state.default_vendor
      );
      if (default_vendor) {
        setSelectedDefaultVendor({
          label: default_vendor.name,
          value: default_vendor,
        });
      }
    }
  }, [state]);

  useEffect(() => {
    if (PID) {
      const result = async () => {
        const productSnapShot = await getCatalogProductBySku(PID);
        let data = productSnapShot;
        setState({
          ...state,
          brand: data.brand ? data.brand : "",
          model: data.model ? data.model : "",
          sku: data.sku ? data.sku : "",
          product: data.product ? data.product : "",
          product_type: data.product_type ? data.product_type : "",
          description: data.description ? data.description : "",
          affinity_product_category_id: data.affinity_product_category_id
            ? data.affinity_product_category_id
            : "",
          default_vendor: data.default_vendor
            ? data.default_vendor
            : "White Label DTG",
          default_file_type: data.default_file_type
            ? data.default_file_type
            : "png",
        });

        const getProofTemplates = await getProofTemplatesBySku(PID);
        setProofTemplates(getProofTemplates);

        const getPrices = await getCatalogProductPricesBySku(PID);
        setPrices(getPrices);

        const getVendors = await getCatalogProductVendorsBySku(PID);
        setVendors(getVendors);

        const getImages = await getCatalogProductImagesBySku(PID);
        setImages(getImages);
      };
      result();
    }
  }, [PID]);

  const handleSelectAffinityCategory = (value) => {
    setSelectedAffinityCategory(value);
  };

  const handleSelectedDefaultVendor = (value) => {
    setSelectedDefaultVendor(value);
  };

  // uploader

  const handlePsdUploadChange = (e) => {
    return setPsdFile(e.target.files[0]);
  };

  const handlePsdUpload = async (e) => {
    e.preventDefault();
    var result = await getProofTemplateUploadUrl(
      `1/${psdFile.name}`,
      "template",
      "image/*"
    );
    if (!result) {
      return;
    }
    const config = {
      headers: {
        "Content-Type": "image/*",
      },
      onUploadProgress: function (progressEvent) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setPsdState({
          ...state,
          progress: `${percentCompleted}%`,
        });
      },
    };
    return axios
      .put(result.data.url, psdFile, config)
      .then((res) => {
        setPsdState({
          ...state,
          progress: "Success",
          url: `https://uploadtemplate-greekhouse.s3.us-west-1.amazonaws.com/1/${res.config.data.name}`,
        });
      })
      .catch((e) => {
        toast.error(e.message, { duration: 5000 });
        setPsdState({
          ...state,
          progress: e,
        });
      });
  };

  const handleCsvUploadChange = (e) => {
    let fn = e.target.files[0];
    return setCsvFile(fn);
  };

  const handleCsvUpload = async (e) => {
    e.preventDefault();
    const result = await getProofTemplateUploadUrl(
      `colors/${csvFile.name}`,
      "preview",
      "text/csv"
    );
    if (!result) {
      return;
    }
    const config = {
      headers: {
        "Content-Type": "text/csv",
      },
      onUploadProgress: function (progressEvent) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setCsvState({
          ...state,
          progress: `${percentCompleted}%`,
        });
      },
    };
    return axios
      .put(result.data.url, csvFile, config)
      .then((res) => {
        setCsvState({
          ...state,
          progress: "Success",
          url: `https://previewtemplate-greekhouse.s3.us-west-1.amazonaws.com/colors/${res.config.data.name}`,
        });
      })
      .catch((e) => {
        toast.error(e.message, { duration: 5000 });
        setCsvState({
          ...state,
          progress: e,
        });
      });
  };

  const saveAssumedData = async () => {
    try {
      let fileReader = new FileReader();
      const handleFileRead = async () => {
        // READ CONTENT OF CSV AND SAVE DATA TO PRODUCT CATALOG
        const content = fileReader.result;
        if (typeof content === "string") {
          let rows = content.split(/\r\n|\n/);
          // CONSTRUCT PRODUCT CATALOG IMAGE DATA
          let mappedImages = rows
            .map(function (row) {
              let color = row.split(",")[0] ? row.split(",")[0] : "undefined";
              let hex = row.split(",")[1] ? row.split(",")[1] : "#ffffff";
              let view = csvFile.name.split("-")[1].split(".")[0]
                ? csvFile.name.split("-")[1].split(".")[0]
                : "n/a";
              let folder = csvFile.name.split(".")[0];
              let key = `${folder}-${color.toLowerCase().replace(/\s/g, "")}`;
              return {
                id: `${state.brand}-${state.model}-${state.sku}-${color}}-${view}`
                  .replace(/\W+/g, "-")
                  .toLowerCase(),
                brand: state.brand,
                model: state.model,
                sku: state.sku,
                color: color,
                hex: hex,
                color_csv_name: csvFile.name,
                image_url: `https://previewtemplate-greekhouse.s3.us-west-1.amazonaws.com/${folder}/${key}.png`,
                proof_template_name: psdFile.name,
                view: view,
              };
            })
            .filter((x) => x.color !== undefined || x.color !== "")
            .filter((image) => image.color !== "name")
            .filter((image) => image.hex !== "hex");
          await saveImages(mappedImages);
        }
      };
      fileReader.onloadend = handleFileRead;
      fileReader.readAsText(csvFile);
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const saveImages = async (filtered) => {
    return Promise.all(
      filtered.map(async function (image) {
        return createCatalogProductImage(image);
      })
    );
  };

  const deleteAllImages = async () => {
    return deleteImagesBySku(state.sku)
      .then(() => {})
      .catch((e) => {});
  };

  const downloadCsvSample = () => {
    try {
      const filename = "colors-sample.csv";
      const url =
        "https://uploadtemplate-greekhouse.s3.us-west-1.amazonaws.com/colors/colors-sample.csv";
      var xhr = new XMLHttpRequest();
      xhr.responseType = "blob";
      xhr.onload = function () {
        var blob = xhr.response;
        var data = new Blob([blob], { type: "text/csv" });
        var csvURL = window.URL.createObjectURL(data);
        var tempLink = document.createElement("a");
        tempLink.href = csvURL;
        tempLink.setAttribute("download", filename);
        tempLink.click();
      };
      xhr.open("GET", url);
      xhr.send();
    } catch (e) {
      return console.log(e);
    }
  };

  const handleChange = (field, e) => {
    setState({
      ...state,
      [field]: e.target.value,
      [field + "Errors"]: "",
    });
  };

  const uploadProofTemplateJobJson = async () => {
    let savedAssumedData = await saveAssumedData();
    if (savedAssumedData) {
      const data = JSON.stringify({ proofTemplate: psdState.url });
      const result = await getProofTemplateUploadUrl(
        `1/${psdFile.name.split(".")[0]}.json`,
        "template",
        "application/json"
      );
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        onUploadProgress: function (progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          console.log(`${percentCompleted}%`);
        },
      };
      console.log("url", result.data.url);
      return axios
        .put(result.data.url, data, config)
        .then(async (res) => {
          console.log("post json result", res);
          let query = await getProofTemplatesBySku(PID);
          if (query && query.length > 0) {
            console.log("uploadProofTemplateJobJson query", query);
          }
          let templateData = {
            id: state.sku.replace(/\_/g, "-") + "-" + uuid.v4(),
            brand: state.brand,
            model: state.model,
            sku: state.sku,
            design_areas: sortDesignAreas(
              designAreas.concat(manualDesignAreas)
            ),
            color_csv_name: csvFile.name,
            color_csv_url: csvState.url,
            proof_template_name: psdFile.name,
            proof_template_url: psdState.url,
            created_at: new Date().getTime().toString(),
            updated_at: new Date().getTime().toString(),
          };
          console.log("data", templateData);
          await createProofTemplate(templateData)
            .then((res) => {
              toast.success("saved", { duration: 5000 });
              // clear fields
              setPsdFile(null);
              setCsvFile(null);
              setPsdState({
                url: "",
                progress: "0",
              });
              setCsvState({
                url: "",
                progress: "0",
              });
              setDesignAreas([]);
              setManualDesignAreas([]);
              setNewDesignArea("");
            })
            .catch((e) => {
              toast.error(e.message, { duration: 5000 });
            });
        })
        .catch((e) => {
          toast.error(e.message, { duration: 5000 });
        });
    }
  };

  // Each key must match the mockup PSD's layer name exactly — the renderer looks
  // the layer up by this string and silently falls back to the front layer when it
  // cannot find it. Areas outside this list can still be typed in the free-text
  // box below; these are just the ones offered as checkboxes. There is deliberately
  // no bare "sleeve" option: it does not say which arm.
  const default_design_areas = [
    ...PRINTED_DESIGN_AREAS,
    ...STOREFRONT_RENDER_AREAS,
    NECK_LABEL_AREA,
  ];

  const [designAreas, setDesignAreas] = useState([]);
  const [manualDesignAreas, setManualDesignAreas] = useState([]);
  const [newDesignArea, setNewDesignArea] = useState("");

  const handleSetDesignAreas = (value) => {
    if (designAreas.includes(value.target.name)) {
      let newAreas = designAreas.filter((store) => store !== value.target.name);
      return setDesignAreas(newAreas);
    } else {
      return setDesignAreas([...designAreas, value.target.name]);
    }
  };

  const handleDesignAreaChange = (value) => {
    setNewDesignArea(value.target.value);
  };

  const addDesignArea = (area) => {
    if (!area.trim()) {
      return;
    }
    if (isBareSleeve(area)) {
      toast.error(
        "\"sleeve\" does not say which arm — add left_sleeve or right_sleeve instead",
        { duration: 5000 }
      );
      return;
    }
    setManualDesignAreas([...manualDesignAreas, area.trim()]);
    setNewDesignArea("");
  };

  const removeManualDesignArea = (value) => {
    const newManualDesignAreas = manualDesignAreas.filter((x) => x !== value);
    setManualDesignAreas(newManualDesignAreas);
  };

  function PriceTable() {
    let [priceState, setPriceState] = useState({
      price: "",
      size: "",
      weight: "",
      position: "",
      licensing: [],
    });

    const handlePriceState = (field, e) => {
      setPriceState({
        ...priceState,
        [field]: e.target.value,
        [field + "Errors"]: "",
      });
    };

    const addPrice = async () => {
      const priceData = {
        id:
          state.sku.replace(/\_/g, "-") + "-" + new Date().getTime().toString(),
        brand: state.brand,
        model: state.model,
        sku: state.sku,
        currency: "USD",
        number_designs: "1",
        price: priceState.price.replace(/\s+/g, " ").trim(),
        size: priceState.size.replace(/\s+/g, " ").trim(),
        licensing: [],
        weight: priceState.weight,
        weight_unit: "GRAMS",
        position: priceState.position,
      };
      setNewPrices([...newPrices, priceData]);
    };

    const removePrice = async (value) => {
      if (prices.includes(value)) {
        let newPrices = prices.filter((i) => i !== value);
        setPrices(newPrices);
        await removeCatalogProductPrice(value.id)
          .then((res) => console.log(res))
          .catch((e) => console.log(e));
      }
    };

    const removeNewPrice = async (value) => {
      if (newPrices.includes(value)) {
        let np = newPrices.filter((i) => i !== value);
        setNewPrices(np);
      }
    };

    const savePrices = async () => {
      if (!newPrices.length) {
        toast.error("missing new prices", { duration: 5000 });
        return;
      }
      if (!state.sku) {
        toast.error("missing sku", { duration: 5000 });
        return;
      }
      for (let i = 0; i < newPrices.length; i++) {
        const price = newPrices[i];
        console.log("price", price);
        const req = await createCatalogProductPrice(price);
        console.log(req);
      }
      toast.success(`saved`, { duration: 5000 });
    };

    return (
      <div className="my-6">
        {prices ? (
          <div className="flex flex-col w-full">
            <div className="=overflow-x-auto w-full">
              <div className="py-2 align-middle inline-block min-w-full">
                <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-200 table-fixed">
                    <thead className="bg-gray-50">
                      <tr>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Price
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Size
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Weight (Grams)
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Position
                        </th>
                        <th scope="col" className="relative px-6 py-3">
                          <span className="sr-only">Edit</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {prices.map((price, priceIdx) => (
                        <tr
                          key={priceIdx}
                          className={
                            priceIdx % 2 === 0 ? "bg-white" : "bg-gray-50"
                          }
                        >
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {price.price}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {price.size}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {price.weight}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {price.position}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                            <button
                              onClick={() => removePrice(price)}
                              className="text-black hover:text-gray-900"
                            >
                              delete
                            </button>
                          </td>
                        </tr>
                      ))}
                      {newPrices.map((price, priceIdx) => (
                        <tr
                          key={priceIdx}
                          className={
                            priceIdx % 2 === 0 ? "bg-white" : "bg-gray-50"
                          }
                        >
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {price.price}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {price.size}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {price.weight}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {price.position}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                            <button
                              onClick={() => removeNewPrice(price)}
                              className="text-black hover:text-gray-900"
                            >
                              delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>add prices</div>
        )}

        <div className="grid grid-flow-row grid-rows-1 grid-cols-5 gap-6 my-6 border p-8">
          <Input
            label="Price - USD"
            field="price"
            errors={priceState.price_errors}
            value={priceState.price}
            onChange={handlePriceState}
          />
          <Input
            label="Size - SM, MD, etc..."
            field="size"
            errors={priceState.size_errors}
            value={priceState.size}
            onChange={handlePriceState}
          />
          <Input
            label="Weight - Grams"
            field="weight"
            errors={priceState.weight_errors}
            value={priceState.weight}
            onChange={handlePriceState}
          />
          <Input
            label="Position"
            field="position"
            errors={priceState.position_errors}
            value={priceState.position}
            onChange={handlePriceState}
          />
          <div className="px-4 py-3 text-right sm:px-6">
            <button
              onClick={() => addPrice()}
              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-black hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
            >
              Add Price
            </button>
          </div>
        </div>
        <div className="px-4 py-3 text-right sm:px-6">
          <button
            onClick={() => savePrices()}
            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-black hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
          >
            Save Prices
          </button>
        </div>
      </div>
    );
  }

  function VendorConstructor() {
    let [vendorState, setVendorState] = useState({
      size: "",
      vendor_sku: "",
      vendor_name: "",
      vendor_name_id: "",
      print_type: "",
      color: "",
      gtin: "",
    });

    let [newSkus, setNewSkus] = useState([]);

    const handleVendorState = (field, e) => {
      setVendorState({
        ...vendorState,
        [field]: e.target.value,
        [field + "Errors"]: "",
      });
    };

    const addVendorSku = async () => {
      const vendorData = {
        id: state.sku.replace(/\_/g, "-") + "-" + uuid.v4(),
        brand: state.brand,
        model: state.model,
        sku: state.sku,
        color: vendorState.color,
        size: vendorState.size,
        vendor_name: vendorState.vendor_name,
        vendor_name_id: vendorState.vendor_name_id,
        vendor_sku: vendorState.vendor_sku,
        print_type: vendorState.print_type,
        gtin: vendorState.gtin,
      };
      setVendors([...vendors, vendorData]);
      setNewSkus([...newSkus, vendorData]);
    };

    const removeVendorSku = async (value) => {
      if (vendors.includes(value)) {
        let newVendors = vendors.filter((i) => i !== value);
        setVendors(newVendors);
        return removeCatalogVendorSku(value.id);
      }
    };

    const saveVendors = async () => {
      newSkus.forEach(async function (x) {
        await createCatalogVendorSku(x);
      });
      toast.success(`saved`, { duration: 5000 });
    };

    return (
      <div className="my-6">
        <p>Skus</p>
        {vendors ? (
          <div className="flex flex-col w-full">
            <div className="=overflow-x-auto w-full">
              <div className="py-2 align-middle inline-block min-w-full">
                <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg p-4">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          vendor_name
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          vendor_name_id
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          vendor_sku
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          print_type
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          gtin
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          color
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          size
                        </th>
                        <th scope="col" className="relative px-6 py-3">
                          <span className="sr-only">Edit</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {vendors.map((vendor, vendorIdx) => (
                        <tr
                          key={vendorIdx}
                          className={
                            vendorIdx % 2 === 0 ? "bg-white" : "bg-gray-50"
                          }
                        >
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            {vendor.vendor_name}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {vendor.vendor_name_id}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {vendor.vendor_sku}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {vendor.print_type}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {`${vendor.gtin}`}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {vendor.color}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {vendor.size}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                            <button
                              onClick={() => removeVendorSku(vendor)}
                              className="text-black hover:text-gray-900"
                            >
                              delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>add vendor sku</div>
        )}

        <div className="grid grid-cols-1 gap-6 my-6 border p-4">
          <Input
            label="Vendor Name"
            field="vendor_name"
            errors={vendorState.vendor_name_errors}
            value={vendorState.vendor_name}
            onChange={handleVendorState}
          />
          <Input
            label="Vendor Name ID"
            field="vendor_name_id"
            errors={vendorState.vendor_name_id_errors}
            value={vendorState.vendor_name_id}
            onChange={handleVendorState}
          />
          <Input
            label="Vendor Sku"
            field="vendor_sku"
            errors={vendorState.vendor_sku_errors}
            value={vendorState.vendor_sku}
            onChange={handleVendorState}
          />
          <Input
            label="Print Type"
            field="print_type"
            errors={vendorState.print_type_errors}
            value={vendorState.print_type}
            onChange={handleVendorState}
          />
          <Input
            label="GTIN"
            field="gtin"
            errors={vendorState.gtin_errors}
            value={vendorState.gtin}
            onChange={handleVendorState}
          />
          <Input
            label="Color"
            field="color"
            errors={vendorState.color_errors}
            value={vendorState.color}
            onChange={handleVendorState}
          />
          <Input
            label="Size - SM, MD, etc..."
            field="size"
            errors={vendorState.size_errors}
            value={vendorState.size}
            onChange={handleVendorState}
          />
          <div className="px-4 py-3 text-right sm:px-6">
            <button
              onClick={() => addVendorSku()}
              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-black hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
            >
              Add Vendor Sku
            </button>
          </div>
        </div>
        <div className="px-4 py-3 text-right sm:px-6">
          <button
            onClick={() => saveVendors()}
            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-black hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
          >
            Save Vendor Skus
          </button>
        </div>
      </div>
    );
  }

  function ImageConstructor() {
    return (
      <div className="my-6">
        <p className="my-6">Images derived from Color CSV & Proof Templates:</p>
        {images ? (
          <div className="flex flex-col w-full">
            <div className="=overflow-x-auto w-full">
              <div className="py-2 align-middle inline-block min-w-full">
                <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Color
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Hex
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Image URL
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          View
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {images.map((image, imageIdx) => (
                        <tr
                          key={imageIdx}
                          className={
                            imageIdx % 2 === 0 ? "bg-white" : "bg-gray-50"
                          }
                        >
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            {image.color}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {image.hex}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            <div className="w-32 h-32">
                              <img
                                className="object-fill w-full"
                                src={image.image_url}
                              />
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {image.view}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>upload color csv and proof template</div>
        )}
      </div>
    );
  }

  const saveDetails = async () => {
    if (state.sku === "") {
      return toast.error("missing sku", { duration: 5000 });
    }
    if (state.sku) {
      const productSnapShot = await getCatalogProductBySku(PID);
      if (productSnapShot) {
        let data = {
          id: state.sku,
          affinity_product_category_id: selectedAffinityCategory
            ? selectedAffinityCategory.value?.id
            : "n/a",
          brand: state.brand,
          description: state.description,
          model: state.model,
          sku: state.sku,
          product: state.sku,
          product_type: state.product_type,
          default_vendor: selectedDefaultVendor
            ? selectedDefaultVendor.value?.name
            : "White Label DTG",
          default_file_type: state.default_file_type,
        };
        return updateCatalogProduct(data)
          .then((res) => {
            toast.success(`updated`, { duration: 5000 });
            history.push({
              pathname: `/product-catalog/${state.sku}`,
            });
          })
          .catch((e) => {
            toast.error(e.message, { duration: 5000 });
          });
      } else {
        let data = {
          id: state.sku,
          brand: state.brand,
          model: state.model,
          sku: state.sku,
          description: state.description,
          affinity_product_category_id: selectedAffinityCategory
            ? selectedAffinityCategory.value?.id
            : "n/a",
          product_type: state.product_type,
          default_vendor: "White Label DTG",
          image_url:
            "https://previewtemplate-greekhouse.s3.us-west-1.amazonaws.com/missing-image.png",
        };
        return createCatalogProduct(data)
          .then((res) => {
            toast.success(`saved`, { duration: 5000 });
            history.push({
              pathname: `/product-catalog/${state.sku}`,
            });
          })
          .catch((e) => {
            toast.error(e.message, { duration: 5000 });
          });
      }
    }
  };

  const removeProofTemplate = async (template) => {
    return deleteImagesBySku(template.sku)
      .then(() => {
        return deleteProofTemplate(template.id)
          .then(() => {
            toast.success(`removed`, { duration: 5000 });
          })
          .catch((e) => {
            toast.error(e.message, { duration: 5000 });
          });
      })
      .catch((e) => {
        toast.error(e.message, { duration: 5000 });
      });
  };

  const deleteThisSku = () => {
    return deleteCatalogProduct(state.sku)
      .then(() => {
        toast.success(`removed`, { duration: 5000 });
      })
      .catch((e) => {
        toast.error(e.message, { duration: 5000 });
      });
  };

  return (
    <div className="w-full mx-auto p-16">
      <div className="px-4 py-5 bg-white space-y-6 sm:p-6">
        <div className="grid grid-cols-1 gap-6">
          <Input
            label="Brand - {catalog-brand}"
            field="brand"
            errors={state.brand_errors}
            value={state.brand}
            placeholder="ex: Bella + Canvas"
            onChange={handleChange}
          />
          <Input
            label="Model - {catalog-model}"
            field="model"
            errors={state.model_errors}
            value={state.model}
            placeholder="ex: Unisex Jersey Short Sleeve Tee"
            onChange={handleChange}
          />
          <Input
            label="Sku: {catalog-sku}"
            field="sku"
            errors={state.sku_errors}
            value={state.sku}
            placeholder="ex: 3001"
            onChange={handleChange}
          />
          <Input
            label="Greek House Product Category: {catalog-product_type}"
            field="product_type"
            errors={state.type_errors}
            value={state.product_type}
            placeholder="ex: T-Shirt"
            onChange={handleChange}
          />
          <Input
            label="Description: {catalog-description}"
            field="description"
            errors={state.description_errors}
            value={state.description}
            placeholder="ex: An interesting description about this product"
            onChange={handleChange}
          />
          <p>Affinity License Category</p>
          <Select
            isSearchable
            name="affinity_categories"
            options={affinityCategories}
            value={selectedAffinityCategory}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={handleSelectAffinityCategory}
          />
          <p>Default Vendor</p>
          <Select
            name="default_vendor"
            options={defaultVendors}
            value={selectedDefaultVendor}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={handleSelectedDefaultVendor}
          />
          <FileFormatPicker
            selected={state.default_file_type}
            setSelected={(e) =>
              setState({
                ...state,
                default_file_type: e.target.id,
              })
            }
          />
          <div className="px-4 py-3 text-right sm:px-6">
            <button
              onClick={() => saveDetails()}
              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-black hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
            >
              {PID ? <p>Save</p> : <p>Next</p>}
            </button>
          </div>

          {PID && (
            <div>
              <Disclosure as="div" className="pt-6">
                {({ open }) => (
                  <>
                    <dt className="text-lg border-b">
                      <Disclosure.Button className="text-left w-full flex justify-between items-start text-gray-400">
                        <span className="font-medium text-gray-900">
                          Proof Templates
                        </span>
                        <span className="ml-6 h-7 flex items-center">
                          <ChevronDownIcon
                            className={classNames(
                              open ? "-rotate-180" : "rotate-0",
                              "h-6 w-6 transform"
                            )}
                            aria-hidden="true"
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className="mt-2 pr-12">
                      <div className="py-6 border-b mb-4">
                        <form className="w-full" onSubmit={handlePsdUpload}>
                          <p className="font-lato font-semibold text-md mb-3">
                            Proof Template PSD
                          </p>
                          <div className="flex items-center">
                            <input
                              type="file"
                              onChange={handlePsdUploadChange}
                            />
                            <p>{psdState.progress}</p>
                            <button
                              className="text-md underline p-2 m-2"
                              disabled={!psdFile}
                            >
                              upload
                            </button>
                          </div>
                        </form>
                      </div>

                      <div className="py-6 border-b mb-4">
                        <p className="font-lato font-semibold text-md mb-3">
                          Color CSV
                        </p>
                        <div onClick={downloadCsvSample}>Download example</div>
                        <form className="w-full" onSubmit={handleCsvUpload}>
                          <div className="flex items-center">
                            <input
                              type="file"
                              onChange={handleCsvUploadChange}
                            />
                            <p>{csvState.progress}</p>
                            <button
                              className="text-md underline p-2 m-2"
                              disabled={!csvFile}
                            >
                              upload
                            </button>
                          </div>
                        </form>
                      </div>
                      <div className="bg-white p-4">
                        <div className="w-full">
                          <p className="font-lato font-semibold text-md">
                            Template Design Areas - must match layer name
                            exactly
                          </p>
                          <div className="w-full flex flex-row space-x-4">
                            <div className="grid grid-flow-row grid-cols-3">
                              {default_design_areas.map(function (area) {
                                return (
                                  <div
                                    key={area.key}
                                    className="w-full flex flex-row items-center space-x-4 h-12 p-2"
                                  >
                                    <input
                                      id={canonicalizeDesignArea(area.key)}
                                      name={area.key}
                                      type="checkbox"
                                      checked={designAreas.includes(area.key)}
                                      className="focus:ring-dustyrose h-4 w-4 text-dustyrose border-gray-300 rounded"
                                      onChange={handleSetDesignAreas}
                                    />
                                    <div className="flex flex-col">
                                      <p>{area.label}</p>
                                      <p className="text-xs text-gray-500">
                                        {area.key}
                                      </p>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          <p className="text-xs text-gray-500">
                            proof_combo, proof_front and proof_back are not
                            printed — they become the Shopify product
                            photography. proof_combo works on its own and becomes
                            the main image; proof_front and proof_back only take
                            effect together.
                          </p>
                          <div className="grid grid-cols-3 gap-2">
                            {manualDesignAreas.map(function (area, idx) {
                              return (
                                <div
                                  className="border m-2 p-2 rounded"
                                  key={`${area}-${idx}`}
                                >
                                  <button
                                    className="flex flex-col text-left mr-4"
                                    onClick={() => removeManualDesignArea(area)}
                                  >
                                    <p className="text-xs">{area}</p>
                                    <p className="underline">X</p>
                                  </button>
                                </div>
                              );
                            })}
                          </div>
                          <div>
                            <p className="font-lato font-semibold text-md mb-3">
                              Free Design Area - must match layer name exactly
                            </p>
                            <p className="text-xs text-gray-500 mb-2">
                              An area we do not recognize is kept as typed — it
                              sorts after the known areas and is title-cased for
                              fulfillment.
                            </p>
                            <div className="mt-1">
                              <input
                                type="text"
                                name="designArea"
                                id="designArea"
                                className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                placeholder="e.g. left_sleeve"
                                value={newDesignArea}
                                onChange={handleDesignAreaChange}
                              />
                            </div>
                            <div className="flex-1 min-w-0">
                              <button
                                onClick={() => addDesignArea(newDesignArea)}
                                className="bg-black px-4 py-2 text-white my-4 mr-4"
                              >
                                Add Design Area
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="px-4 py-3 text-right sm:px-6">
                        <button
                          onClick={() => uploadProofTemplateJobJson()}
                          className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-black hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
                        >
                          Submit Template
                        </button>
                      </div>
                      {proofTemplates && proofTemplates.length > 0 && (
                        <div>
                          {proofTemplates.map(function (template, index) {
                            return (
                              <div
                                className="flex flex-row justify-between p-8 border rounded-sm"
                                key={index}
                              >
                                <div>
                                  <p>
                                    filename: {template.proof_template_name}
                                  </p>
                                  <p>
                                    areas:{" "}
                                    {sortDesignAreas(template.design_areas)
                                      .map(designAreaLabel)
                                      .join(", ")}
                                  </p>
                                  <p className="text-xs text-gray-500">
                                    {sortDesignAreas(
                                      template.design_areas
                                    ).join(", ")}
                                  </p>
                                  <p>time created: {template.created_at}</p>
                                </div>

                                <button
                                  className="underline"
                                  onClick={() => removeProofTemplate(template)}
                                >
                                  Remove
                                </button>
                              </div>
                            );
                          })}
                        </div>
                      )}
                      <button
                        onClick={() => deleteAllImages()}
                        className="underline px-4 py-2"
                      >
                        Clear All Images
                      </button>
                      {ImageConstructor()}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>

              <Disclosure as="div" className="pt-6 border-b">
                {({ open }) => (
                  <>
                    <dt className="text-lg">
                      <Disclosure.Button className="text-left w-full flex justify-between items-start text-gray-400">
                        <span className="font-medium text-gray-900">
                          Prices, Weights, and Listing Position
                        </span>
                        <span className="ml-6 h-7 flex items-center">
                          <ChevronDownIcon
                            className={classNames(
                              open ? "-rotate-180" : "rotate-0",
                              "h-6 w-6 transform"
                            )}
                            aria-hidden="true"
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className="mt-2 pr-12">
                      {<PriceTable />}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>

              <Disclosure as="div" className="pt-6 border-b">
                {({ open }) => (
                  <>
                    <dt className="text-lg">
                      <Disclosure.Button className="text-left w-full flex justify-between items-start text-gray-400">
                        <span className="font-medium text-gray-900">
                          Vendors
                        </span>
                        <span className="ml-6 h-7 flex items-center">
                          <ChevronDownIcon
                            className={classNames(
                              open ? "-rotate-180" : "rotate-0",
                              "h-6 w-6 transform"
                            )}
                            aria-hidden="true"
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className="mt-2">
                      {VendorConstructor()}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            </div>
          )}
          <div className="p-8 border rounded-md flex justify-between items-center">
            <h1 className="text-red-600 font-bold">DANGER ZONE</h1>
            <button
              onClick={() => deleteThisSku()}
              className="bg-red-600 text-white px-4 py-2 rounded-md"
            >
              DELETE
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
